import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FileText, Users, BarChart3, ListChecks, ArrowRight } from "lucide-react";
import { StatCard } from "@/components/StatCard";
import { api, fmtDate } from "@/lib/api";

export default function AdminOverview() {
  const [stats, setStats] = useState({});
  const [recent, setRecent] = useState([]);

  useEffect(() => {
    api.get("/admin/stats").then((r) => setStats(r.data));
    api.get("/admin/results").then((r) => setRecent(r.data.slice(0, 6)));
  }, []);

  return (
    <div>
      <div className="small-label">Control Panel</div>
      <h1 className="font-heading text-4xl sm:text-5xl font-bold tracking-tight mt-2">Overview</h1>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mt-8">
        <StatCard label="Tests" value={stats.tests ?? "-"} icon={FileText} testId="admin-stat-tests" />
        <StatCard label="Questions" value={stats.questions ?? "-"} icon={ListChecks} testId="admin-stat-questions" delay={60} />
        <StatCard label="Students" value={stats.students ?? "-"} icon={Users} testId="admin-stat-students" delay={120} />
        <StatCard label="Submissions" value={stats.attempts ?? "-"} icon={BarChart3} testId="admin-stat-attempts" delay={180} />
      </div>
      <div className="mt-10 bg-white border border-slate-200 rounded-xl">
        <div className="flex items-center justify-between px-6 py-4 border-b border-slate-200">
          <h2 className="font-heading font-semibold">Recent Submissions</h2>
          <Link to="/admin/results" className="text-sm text-[#2563EB] hover:underline flex items-center gap-1" data-testid="overview-view-all-results">View all<ArrowRight className="h-4 w-4" /></Link>
        </div>
        {recent.length === 0 ? <p className="p-8 text-center text-slate-500 text-sm">No submissions yet.</p> : (
          <ul className="divide-y divide-slate-100">
            {recent.map((a) => (
              <li key={a.id} className="px-6 py-3 flex items-center justify-between text-sm">
                <div><span className="font-medium">{a.student_name}</span><span className="text-slate-500"> · {a.test_title}</span></div>
                <div className="flex items-center gap-4">
                  <span className="text-slate-400 hidden sm:inline">{fmtDate(a.submitted_at)}</span>
                  <span className={`font-mono font-semibold ${a.passed ? "text-green-700" : "text-red-700"}`}>{Math.round(a.percentage)}%</span>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
